export default __webpack_public_path__ + "static/media/lead-score-toolbox.8b3af5b3.svg";